import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { BaseService } from 'src/app/services/base.service';


@Injectable({
  providedIn: 'root',
})
export class GriddingStatusService extends BaseService{

  private API_ANALYSIS_MANAGEMENT_URL = this.API_BASE_URL + "analysis-management";
  

  constructor(private httpClient: HttpClient,
     private _snackBar: MatSnackBar,
     private translate: TranslateService,) {
         super()
    
   }


  getGriddingTimelineData(tenantId: number, analysisType: string): Observable<any> {

          let params = new HttpParams();


        if (tenantId) {
            params = params.append('tenantId', tenantId);
        }

        if (analysisType) {
            if (Array.isArray(analysisType)) {
                analysisType.forEach(type => {
                    params = params.append('analysisType', type);
                });
            } else {
                params = params.append('analysisType', analysisType);
            }
        }

          return this.httpClient.get<any>(this.API_ANALYSIS_MANAGEMENT_URL + `/gridding/dates`, {params})
            .pipe(
              catchError(err => {
                this.hasError.next(true);
                this._snackBar.open(this.translate.instant('DATA-SERVICE.ANALYSIS-COLOR'), this.translate.instant('SNACKBAR.DISMISS'), {
                  duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
              })
            );
  }
}
